import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Mail, ArrowLeft, Loader2, CheckCircle2 } from "lucide-react";
import api from "@/lib/api";
import { errorMessage } from "@/lib/errors";

export default function ForgotPassword() {
  const { t } = useTranslation();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email: email.trim().toLowerCase() });
      setSubmitted(true);
    } catch (err) {
      setError(errorMessage(err, t("common.error")));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-linen flex items-center justify-center p-4" data-testid="forgot-password-page">
      <div className="w-full max-w-md">
        <Link to="/login" className="inline-flex items-center gap-1 text-sm text-smoke hover:text-worker mb-4">
          <ArrowLeft size={14} /> {t("auth.backToLogin")}
        </Link>
        <div className="card-base p-8">
          {submitted ? (
            <div className="text-center" data-testid="forgot-success">
              <CheckCircle2 size={48} className="mx-auto text-green-600 mb-3" />
              <h1 className="font-display text-2xl font-bold text-worker">{t("auth.forgotSent")}</h1>
              <Link to="/login" className="fx-btn fx-btn--secondary mt-6 inline-flex" data-testid="back-to-login-btn">
                {t("auth.backToLogin")}
              </Link>
            </div>
          ) : (
            <>
              <h1 className="font-display text-2xl font-bold text-worker">{t("auth.forgotTitle")}</h1>
              <p className="mt-2 text-smoke text-sm">{t("auth.forgotSubtitle")}</p>
              <form onSubmit={submit} className="mt-6 space-y-4">
                <div>
                  <label className="label-base">{t("auth.email")}</label>
                  <div className="relative">
                    <Mail size={18} className="absolute left-3 top-1/2 -translate-y-1/2 text-smoke" />
                    <input
                      type="email"
                      required
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      className="input-base pl-10"
                      placeholder={t("auth.emailPlaceholder")}
                      data-testid="forgot-email-input"
                    />
                  </div>
                </div>
                {error && (
                  <div className="bg-red-50 border border-red-200 rounded-sm p-2 text-sm text-red-700" data-testid="forgot-error">
                    {error}
                  </div>
                )}
                <button type="submit" disabled={loading} className="fx-btn fx-btn--primary w-full" data-testid="forgot-submit">
                  {loading ? <Loader2 className="animate-spin" size={16} /> : null}
                  {t("auth.forgotBtn")}
                </button>
              </form>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
